import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';
import { getLocalStorageLanguage } from 'utils/utils';

const CURRENT_LANGUAGE = getLocalStorageLanguage();

export const webServiceApi = createApi({
  reducerPath: 'webServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetContactData: builder.query<any, any>({
      query: ({ language = CURRENT_LANGUAGE }) => `web/contact?locale=${language}`,
    }),
    GetFaqCategories: builder.query<any, any>({
      query: ({ language = CURRENT_LANGUAGE }) => `web/faq/categories?locale=${language}`,
    }),
    GetFaqKeywords: builder.query<any, any>({
      query: ({ language = CURRENT_LANGUAGE }) => `web/faq/keywords?locale=${language}`,
    }),
    GetQuestionsByCategoryId: builder.query<any, any>({
      query: ({ language = CURRENT_LANGUAGE, categoryId }) =>
        `web/faq?categoryId=${categoryId}&locale=${language}`,
    }),
    GetQuestionsByText: builder.query<any, any>({
      query: ({ text, language = CURRENT_LANGUAGE }) =>
        `web/faq/search?txt=${text}&locale=${language}`,
    }),
    GetQuestionsById: builder.query<any, any>({
      query: ({ keywordId, language = CURRENT_LANGUAGE }) =>
        `web/faq/searchByKeyword/?keywordId=${keywordId}&locale=${language}`,
    }),
    GetPrimaryBanners: builder.query<any, any>({
      query: ({ language = CURRENT_LANGUAGE }) => `web/banner/primary/?locale=${language}`,
    }),
    GetSecondaryBanners: builder.query<any, any>({
      query: ({ language = CURRENT_LANGUAGE }) => `/web/banner/secondary/?locale=${language}`,
    }),
    GetTertiaryBanners: builder.query<any, any>({
      query: ({ language = CURRENT_LANGUAGE }) => `web/banner/tertiary/?locale=${language}`,
    }),
    GetFares: builder.query<any, any>({
      query: ({ language = CURRENT_LANGUAGE }) => `fare/getFaresTable?locale=${language}`,
    }),
    GetNoteById: builder.query<any, any>({
      query: ({ language = CURRENT_LANGUAGE, id }) => `web/text/?id=${id}&locale=${language}`,
    }),
    GetTextByCode: builder.query<any, any>({
      query: ({ language = CURRENT_LANGUAGE, code }) =>
        `/web/textByCode/?code=${code}&locale=${language}`,
    }),
    GetDownloadFile: builder.query<any, any>({
      query: (fileId) =>({
        url: `/web/downloadFile/?fileId=${fileId}`,
        responseHandler: async (response:any) => {
          if (response.ok) {
            const url = window.URL.createObjectURL(await response.blob());
            return url;
          }
          return null;
        },
    })}),
    GetDownloadFileByAlertAndFileId: builder.query<any, any>({
      query: ({ language = CURRENT_LANGUAGE, alertId, fileId }) =>({
        url: `${enviroments.endPoint}/alert/downloadFile?locale=${language}&announceId=${alertId}&attachmentId=${fileId}`,
        responseHandler: async (response:any) => {
          if (response.ok) {
            const url = window.URL.createObjectURL(await response.blob());
            return url;
          }
          return null;
        },
    })}),
    PostClaimForm: builder.mutation<any, any>({
      query: ({ body, token }) => ({
        url: 'webForms/claim',
        method: 'POST',
        body: body,
        headers: {
          authorization: 'Bearer ' + token,
        },
      }),
    }),
    PostContactForm: builder.mutation<any, any>({
      query: ({ body, token }) => ({
        url: 'webForms/contact',
        method: 'POST',
        body: body,
        headers: {
          authorization: 'Bearer ' + token,
        },
      }),
    }),
  }),
});

export const {
  useLazyGetContactDataQuery,
  useLazyGetFaqCategoriesQuery,
  useLazyGetFaqKeywordsQuery,
  useLazyGetQuestionsByCategoryIdQuery,
  useLazyGetQuestionsByTextQuery,
  useLazyGetQuestionsByIdQuery,
  useLazyGetPrimaryBannersQuery,
  useLazyGetSecondaryBannersQuery,
  useLazyGetTertiaryBannersQuery,
  useLazyGetFaresQuery,
  useLazyGetNoteByIdQuery,
  useLazyGetTextByCodeQuery,
  useLazyGetDownloadFileQuery,
  usePostClaimFormMutation,
  usePostContactFormMutation,
  useLazyGetDownloadFileByAlertAndFileIdQuery
} = webServiceApi;
